<div class="svg" [innerHTML]="qrCode">
</div>
<div class="information">
  <div class="information-row">
    <div class="content">
      <span>{{ config.deviceName }}</span>
    </div>
    <div class="caption">
      <small>{{ 'device-configurations.qr.device-name' | translate }}</small>
    </div>
  </div>
  <div class="information-row">
    <div class="content">
      <span>{{ config.deviceId }}</span>
    </div>
    <div class="caption">
      <small>{{ 'device-configurations.qr.device-id' | translate }}</small>
    </div>
  </div>
  <div class="information-row">
    <div class="content">
      <span>{{ config.companyName }}</span>
    </div>
    <div class="caption">
      <small>{{ 'device-configurations.qr.company-name' | translate }}</small>
    </div>
  </div>
</div>
